const mutations = {
  mutationPermissions(state, payload) {
    state.permissions = payload;
  },

  mutationPermission(state, payload) {
    state.permission = payload;
  },
};

export default mutations;
